class Typography {
	constructor() {
		this.titles = document.querySelectorAll(".title-level-1:not(.no-svg), .title-level-2:not(.no-svg)");
		this.downloadButtons = document.querySelectorAll(".btn-download");
		this.listLinks = document.querySelectorAll(".link-level-1, .link-level-2");

		if (this.titles) {
			this.buildTitles();
		}

		if (this.downloadButtons) {
			this.buildDownloadButtons();
		}

		if (this.listLinks) {
			this.buildListLinks();
		}
	}

	buildTitles() {
		this.titles.forEach(title => {
			title.insertAdjacentHTML("afterbegin",
				`<svg width="3" height="62" viewBox="0 0 3 62" xmlns="http://www.w3.org/2000/svg">
					<path d="M3 31C3 48.1251 1.5 62 1.5 62C1.5 62 0 48.1251 0 31C0 13.8749 1.5 0 1.5 0C1.5 0 3 13.8749 3 31Z" />
				</svg>`);
		});
	}

	buildDownloadButtons() {
		this.downloadButtons.forEach(title => {
			title.insertAdjacentHTML("beforeend",
				`<svg width="21" height="26" viewBox="0 0 21 26" xmlns="http://www.w3.org/2000/svg">
					<path d="M10.6498 22.1803L1.5625 13.093L2.47743 12.1781L10.6498 20.3504L18.8221 12.1781L19.7371 13.093L10.6498 22.1803Z" />
					<path d="M11.3002 0.555191H10.0054V21.2652H11.3002V0.555191Z" />
					<path d="M21 24.0722H0.290039V25.3671H21V24.0722Z" />
				</svg>`);
		});
	}

	buildListLinks() {
		this.listLinks.forEach(title => {
			title.insertAdjacentHTML("beforeend",
				`<svg width="18" height="16" viewBox="0 0 18 16" xmlns="http://www.w3.org/2000/svg">
					<path d="M10.0042 16L18 8L10.0042 -3.49508e-07L7.6737 2.33172L11.7095 6.35068L-2.77597e-07 6.35068L-4.21779e-07 9.64919L11.7095 9.64919L7.6737 13.6681L10.0042 16Z" />
				</svg>`);
		});
	}
}